export default __webpack_public_path__ + "static/media/logo-codelco.d7f34090.svg";